// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-btn .material-icons {
    border: 1px #ddd solid;
    border-radius: 50px;
}

:host ::ng-deep .mat-dialog-container {
    padding: 10px 15px !important;
}

.width-100 {
    width: 100%;
}

.modal-header {
    border-bottom: 1px #ddd solid;
    position: relative;
}

.modal-header h3 {
    color: #003561;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    padding: 0px 10px 10px;
    margin: 0px;
    letter-spacing: 1px;
    font-weight: 400;
}

::ng-deep .mat-dialog-container {
    color: #999;
}

.m-0 {
    margin: 0px;
}

.img-100 {
    width: 100%;
}

.label-text {
    font-family: Roboto, "Helvetica Neue", sans-serif;
    letter-spacing: 1px;
}

.errorMessage {
    color: red;
    margin-top: 0px;
    font-size: 12px;
    /* text-align: center; */
}

:host ::ng-deep .mat-progress-spinner circle,
.mat-spinner circle {
    stroke: #fff;
}

.loading {
    margin: 9px 16px;
}

.mb {
    margin-bottom: 20px;
}

.ml {
    margin-left: 10px;
}

.pointer {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/assign-user/assign-user-popup/assign-user-popup.component.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iDAAiD;IACjD,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".close-btn .material-icons {\n    border: 1px #ddd solid;\n    border-radius: 50px;\n}\n\n:host ::ng-deep .mat-dialog-container {\n    padding: 10px 15px !important;\n}\n\n.width-100 {\n    width: 100%;\n}\n\n.modal-header {\n    border-bottom: 1px #ddd solid;\n    position: relative;\n}\n\n.modal-header h3 {\n    color: #003561;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    padding: 0px 10px 10px;\n    margin: 0px;\n    letter-spacing: 1px;\n    font-weight: 400;\n}\n\n::ng-deep .mat-dialog-container {\n    color: #999;\n}\n\n.m-0 {\n    margin: 0px;\n}\n\n.img-100 {\n    width: 100%;\n}\n\n.label-text {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    letter-spacing: 1px;\n}\n\n.errorMessage {\n    color: red;\n    margin-top: 0px;\n    font-size: 12px;\n    /* text-align: center; */\n}\n\n:host ::ng-deep .mat-progress-spinner circle,\n.mat-spinner circle {\n    stroke: #fff;\n}\n\n.loading {\n    margin: 9px 16px;\n}\n\n.mb {\n    margin-bottom: 20px;\n}\n\n.ml {\n    margin-left: 10px;\n}\n\n.pointer {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
